export default {
    apiUri: process.env.VUE_APP_apiUrl,
    assetUrl: process.env.VUE_APP_assetUrl,
    matchingUrl: process.env.VUE_APP_matchingUrl,
    pricing: 'gross',
    scrollToTop: true
}